"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
require("./card.css");
var Card = function (props) {
    var handleClickEvent = function () {
        window.open(targetUrl, title);
    };
    var title = props.title, description = props.description, imageUrl = props.imageUrl, targetUrl = props.targetUrl, statistics = props.statistics, user = props.user;
    var _a = statistics || {}, active_users = _a.active_users, total_users = _a.total_users, total_messages = _a.total_messages;
    return (react_1.default.createElement("div", { className: "card-container", onClick: handleClickEvent },
        react_1.default.createElement("figure", null,
            react_1.default.createElement("img", { src: imageUrl, alt: title, onError: function (e) {
                    var parent = e.currentTarget.parentElement;
                    if (parent) {
                        parent.style.display = "none";
                    }
                } })),
        react_1.default.createElement("section", { className: "content" },
            react_1.default.createElement("h3", { className: "title" }, title),
            description && react_1.default.createElement("p", { className: "description" }, description),
            user && (react_1.default.createElement("div", { className: "user-info" },
                user.image_url && (react_1.default.createElement("div", { className: "user-info-image" },
                    react_1.default.createElement("img", { src: user.image_url }))),
                user.name && (react_1.default.createElement("div", { className: "user-info-name" },
                    "Posted by: ",
                    user.name)))),
            statistics && (react_1.default.createElement("ul", { className: "stats" },
                react_1.default.createElement("li", null,
                    react_1.default.createElement("span", null, "Total members:"),
                    " ",
                    total_users || 0),
                react_1.default.createElement("li", null,
                    react_1.default.createElement("span", null, "Online now:"),
                    " ",
                    active_users || 0),
                react_1.default.createElement("li", null,
                    react_1.default.createElement("span", null, "Total messages:"),
                    " ",
                    total_messages || 0))))));
};
exports.default = Card;
